/* Refreshes in-store availability on variant change via Section Rendering API */
class CustomStorePickup extends HTMLElement {
  connectedCallback() {
    const formId = this.getAttribute('form-id');
    if (!formId) return;

    document.getElementById(formId)
      ?.addEventListener('variant:changed', this._onVariantChanged.bind(this));
  }

  _onVariantChanged(event) {
    if (!event.detail.variant) {
      this.innerHTML = '';
    } else {
      this._renderForVariant(event.detail.variant.id);
    }
  }

  async _renderForVariant(variantId) {
    const root = window.themeVariables.routes.rootUrlWithoutSlash;
    const response = await fetch(
      `${root}/variants/${variantId}?section_id=custom-store-availability`
    );
    const div = document.createElement('div');
    div.innerHTML = await response.text();
    this.innerHTML = div.firstElementChild.innerHTML.trim();
  }
}

customElements.define('custom-store-pickup', CustomStorePickup);
